import { createFileRoute } from '@tanstack/react-router';
import { AlertPage } from '~/components/dashboards/alert/AlertPage';

export const Route = createFileRoute('/_app/alert-page')({
  component: AlertPageRoute,
});

/**
 * Alert Page — top-level section (moved out of Sales per owner). A live
 * fire/emergency scanner-lead feed (eDispatches / Broadcastify / PulsePoint /
 * CAD) with lead-type cards, a drive-time filter, Maps/Zillow/Earth links, an
 * AI lead-qualifier, and Chase / Visited / NQL / KIA tracking.
 *
 * The UI + Postgres schema (migration 0080_alert_leads) are in place; the
 * scanner-feed ingestion connectors and AI qualifier that WRITE rows into
 * `alert_leads` remain a Phase 3 TODO. The page reads `alert_leads` and shows
 * an empty state until rows exist.
 */
function AlertPageRoute() {
  return (
    <div className="flex flex-col">
      <div className="bg-white border-b border-[var(--color-line)]">
        <div className="px-6 pt-4 pb-4">
          <h1 className="font-display" style={{ fontSize: '24px', fontWeight: 700, color: '#032e5b', margin: 0 }}>
            Alert Page
          </h1>
          <p className="text-sm text-[var(--color-ink-soft)] mt-1">
            Live fire / emergency scanner leads, drive-time filtered, with chase tracking.
          </p>
        </div>
      </div>
      <div className="px-6 py-6 w-full">
        <AlertPage />
      </div>
    </div>
  );
}
